import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { computeMatrixOrigin } from '@/helpers/computeMatrixOrigin'

const getPlatformOrigin: Getter<RootState, RootState> = (state: RootState) => {
  return computeMatrixOrigin({ platform: state.platform })
}

export default getPlatformOrigin
